import styled from "styled-components";

export const Text = styled.div`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: rgba(138, 145, 156, 0.8);
  margin-top: 10px;
`;

export const Grid = styled.div`
  width: 50%;
`;
